export const API_URL = "https://appcarcare.com/api"
export const  PLACES_API_KEY = "AIzaSyBR_1k1yMoO2sSi9CmlQedKpfP2PdHi7YY"
export const  PUSHER_APP_KEY = "ca8704e72107b79b35d7"